import { useEffect } from 'react'
import { NoIndex } from 'src/components'

export default function SplashPage() {
  useEffect(() => {
    window.location.replace('https://trackgood.io/')
  }, [])

  return <NoIndex />
}
